/* kb-spoke.js: behaviour for sections/kb-spoke.liquid.
   Sticky-header offset, reading progress, active contents entry, one-open FAQ (fallback
   for browsers without <details name>), and the calculators from snippets/kb-spoke-tool.liquid. */
(function () {
  var root = document.querySelector('.kbs');
  if (!root) return;

  /* Offset everything sticky by the theme's sticky header, whatever its height. */
  var header = document.querySelector('.shopify-section-group-header-group[class*="main-header"], [id$="__main-header"]');
  function setHead() {
    // The header's bottom EDGE, not its height: the announcement bar above it (2026 top bar) pushes it down, and a
    // height-only offset put the progress line through the middle of the menu (Alexander 2026-10-31).
    var h = header ? Math.round(Math.max(header.getBoundingClientRect().bottom, header.getBoundingClientRect().height)) : 64;
    root.style.setProperty('--head', (h || 64) + 'px');
  }
  setHead();
  window.addEventListener('resize', setHead);
  // The announcement bar renders after this script runs, so measure again once the page has settled.
  window.addEventListener('load', setHead); setTimeout(setHead, 600); setTimeout(setHead, 2000);

  /* Reading progress and the active contents entry (the section whose top is within 200px). */
  var bar = root.querySelector('[data-kbs-progress]');
  var links = [].slice.call(root.querySelectorAll('[data-kbs-toc]'));
  var targets = links.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  /* Mobile: section chips (shown once the hero is past) and the bottom buy bar
     (after the hero, hidden while the shop band is on screen). */
  var chipsNav = root.querySelector('[data-kbs-chips]');
  var chips = [].slice.call(root.querySelectorAll('[data-kbs-chip]'));
  var chipTargets = chips.map(function (a) { return document.getElementById(a.getAttribute('href').slice(1)); });
  var hero = root.querySelector('.kbs-hero');
  var buy = root.querySelector('[data-kbs-bar]');
  var shop = document.getElementById('shop');
  var mobile = window.matchMedia('(max-width: 767.98px)');
  var lastChip = -1;

  var ticking = false;
  function onScroll() {
    ticking = false;
    var d = document.documentElement;
    if (bar) bar.style.width = (100 * d.scrollTop / Math.max(1, d.scrollHeight - d.clientHeight)).toFixed(1) + '%';
    var active = 0;
    targets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top < 200) active = i; });
    links.forEach(function (a, i) { a.setAttribute('aria-current', i === active ? 'true' : 'false'); });

    if (!mobile.matches) return;
    var head = parseInt(getComputedStyle(root).getPropertyValue('--head'), 10) || 56;
    var pastHero = hero ? hero.getBoundingClientRect().bottom < head : false;
    if (chipsNav) {
      chipsNav.classList.toggle('is-on', pastHero);
      var c = 0;
      chipTargets.forEach(function (t, i) { if (t && t.getBoundingClientRect().top < 160) c = i; });
      chips.forEach(function (a, i) { a.setAttribute('aria-current', i === c ? 'true' : 'false'); });
      if (c !== lastChip && chips[c]) {
        lastChip = c;
        var row = chipsNav.firstElementChild;
        row.scrollTo({ left: Math.max(0, chips[c].offsetLeft - 20), behavior: 'smooth' });
      }
    }
    if (buy) {
      var r = shop ? shop.getBoundingClientRect() : null;
      var inShop = r ? (r.top < window.innerHeight && r.bottom > 0) : false;
      buy.classList.toggle('is-on', pastHero && !inShop);
    }
  }
  window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });
  onScroll();

  /* FAQ: only one item open at a time. */
  var faqs = [].slice.call(root.querySelectorAll('.kbs-faq__item'));
  faqs.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) faqs.forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* Mobile: a model table also shows as a list of rows. Built here from the table itself, so the
     HTML carries each table once (a server-rendered copy doubled every row for crawlers). */
  [].slice.call(root.querySelectorAll('[data-kbs-mlist]')).forEach(function (wrap) {
    var key = +wrap.getAttribute('data-kbs-mlist');
    var head = [].slice.call(wrap.querySelectorAll('thead th')).map(function (th) { return th.textContent.trim(); });
    function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
    var list = el('div', 'kbs-mlist'); list.setAttribute('aria-hidden', 'true');
    var h = el('p', 'kbs-mlist__head');
    h.appendChild(el('span', '', head[0] + ' · ' + head[1]));
    if (key >= 0) h.appendChild(el('span', '', head[key]));
    list.appendChild(h);
    [].slice.call(wrap.querySelectorAll('tbody tr')).forEach(function (tr) {
      var cells = [].slice.call(tr.children).map(function (c) { return c.textContent.trim(); });
      var link = tr.querySelector('a.kbs-model'), img = tr.querySelector('img');
      var row = el('a', 'kbs-mlist__row'); row.href = link ? link.getAttribute('href') : '#shop'; row.tabIndex = -1;
      if (img) { var im = el('img'); im.src = img.getAttribute('src'); im.width = 48; im.height = 48; im.alt = ''; im.loading = 'lazy'; row.appendChild(im); }
      else row.appendChild(el('span'));
      var main = el('span', 'kbs-mlist__main'); main.appendChild(el('b', '', cells[0])); main.appendChild(el('small', '', cells[1] || '')); row.appendChild(main);
      var val = el('span', 'kbs-mlist__val');
      if (key >= 0) val.appendChild(el('b', '', cells[key]));
      var others = cells.map(function (c, i) { return i > 1 && i !== key ? head[i] + ': ' + c : ''; }).filter(Boolean).join(' · ');
      if (others) val.appendChild(el('small', '', others));
      row.appendChild(val); list.appendChild(row);
    });
    wrap.parentNode.insertBefore(list, wrap.nextSibling);
  });

  /* Samples: every samples button or link on a guide opens the site samples drawer
     (snippets/site-samples.liquid) instead of leaving the page. The href stays for crawlers
     and as the fallback when the drawer is not on the page. */
  var SAMPLES = /\/(products\/(fabric-samples|tygprover|stoffmuster|echantillons-tissu|wood-samples|traprover|holzmuster|echantillons-bois|frame-samples|stalprover|stahlgestell-muster|echantillons-cadre-acier)|collections\/(samples|materialprover|echantillons-materiaux))\/?([?#]|$)/;
  root.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button > 0) return;
    if (!a.hasAttribute('data-kbs-samples') && !SAMPLES.test(a.pathname || '')) return;
    var tab = document.querySelector('.pdp-samples [data-samples-open]');
    if (!tab) return;
    e.preventDefault();
    var drawer = tab.closest('.pdp-samples');
    if (!drawer.classList.contains('is-open')) tab.click();
    /* Expand the category the link was about (localized handles map to the base handle). */
    var m = (a.pathname || '').match(SAMPLES), h = m && m[2];
    var base = !h ? '' : /fabric|tyg|stoff|tissu/.test(h) ? 'fabric-samples' : /wood|tra|holz|bois/.test(h) ? 'wood-samples' : 'frame-samples';
    var grp = base && drawer.querySelector('[data-samples-group="' + base + '"] details');
    if (grp) grp.open = true;
  });

  /* Calculators. Strings are one '|' list, same order as the snippet documents. */
  [].slice.call(root.querySelectorAll('[data-kbs-tool]')).forEach(function (el) {
    var S = el.getAttribute('data-strings').split('|');
    var dec = S[21] || '.';
    function num(x, d) { var s = x.toFixed(d); if (d && /\.0$/.test(s)) s = s.slice(0, -2); return s.replace('.', dec); }
    var len = el.querySelector('[data-kbs-len]'), outLen = el.querySelector('[data-kbs-out-len]');
    var count = el.querySelector('[data-kbs-count]'), unit = el.querySelector('[data-kbs-unit]');
    var dots = el.querySelector('[data-kbs-dots]'), cta = el.querySelector('[data-kbs-cta]');
    var arm = 0, walls = 0, shape = 0, ends = 0;
    var kind = el.getAttribute('data-kind');

    function seg(attr, set) {
      [].slice.call(el.querySelectorAll('[' + attr + ']')).forEach(function (b) {
        b.addEventListener('click', function () {
          set(+b.getAttribute(attr));
          [].slice.call(el.querySelectorAll('[' + attr + ']')).forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
          run();
        });
      });
    }
    seg('data-kbs-arm', function (v) { arm = v; });
    seg('data-kbs-walls', function (v) { walls = v; });
    seg('data-kbs-ends', function (v) { ends = v; });
    var chair = 0, front = 60;
    seg('data-kbs-chair', function (v) { chair = v; });
    seg('data-kbs-front', function (v) { front = v; });
    /* Table: the slider switches between length (rectangle) and diameter (round). */
    var lenLabel = el.querySelector('[data-kbs-len-label]'), endsGroup = el.querySelector('[data-kbs-ends-group]');
    seg('data-kbs-shape', function (v) {
      shape = v;
      var r = inch ? (v ? [32, 71, 1, 43] : [40, 126, 1, 71]) : (v ? [80, 180, 10, 110] : [100, 320, 10, 180]);
      len.min = r[0]; len.max = r[1]; len.step = r[2]; len.value = r[3];
      if (lenLabel) lenLabel.textContent = lenLabel.getAttribute(v ? 'data-l1' : 'data-l0');
      if (endsGroup) endsGroup.hidden = !!v;
    });

    /* US: the slider is in inches and every label shows inches only; the rule is still metric. */
    var inch = el.getAttribute('data-unit') === 'in';
    function run() {
      var v = +len.value, cm = inch ? v * 2.54 : v;
      if (kind === 'armchair') {
        /* Armchair planner: footprint (Kent 67 x 82, Einar 71 x 81 cm) plus 60 or 90 cm in front. */
        var W = el.querySelector('[data-kbs-w]'), outW = el.querySelector('[data-kbs-out-w]'), box = el.querySelector('[data-kent]');
        var cw = chair ? 71 : 67, cd = chair ? 81 : 82, name = chair ? 'Einar' : 'Kent';
        var w = +W.value, wcm = inch ? w * 2.54 : w;
        outW.textContent = inch ? num(w, 1) + ' in' : w + ' cm';
        outLen.textContent = inch ? num(v, 1) + ' in' : v + ' cm';
        var needD = cd + front, short = Math.max(cw - wcm, needD - cm);
        var u = function (x) { return inch ? num(Math.round(x / 2.54 * 2) / 2, 1) : Math.round(x); };
        count.textContent = short > 0 ? '\u2212' + u(short) + (inch ? ' in' : ' cm') : S[10];
        unit.textContent = name + ' ' + S[12].replace('%w', inch ? num(cw / 2.54, 1) : cw).replace('%d', inch ? num(Math.round(needD / 2.54 * 2) / 2, 1) : needD);
        cta.textContent = S[13].replace('%c', name);
        cta.setAttribute('href', box.getAttribute(chair ? 'data-einar' : 'data-kent'));
        return;
      }
      if (kind === 'table') {
        outLen.textContent = v + (inch ? ' in' : ' cm');
        var t = shape ? Math.floor(Math.PI * cm / 70 + 0.001) : 2 * Math.floor((cm + 0.001) / (arm ? 70 : 60)) + (ends ? 2 : 0);
        count.textContent = t;
        unit.textContent = t === 1 ? S[13] : S[14];
        dots.innerHTML = new Array(Math.min(t, 12) + 1).join('<i></i>');
        cta.textContent = t < 1 ? S[16] : S[15].replace('%n', t);
      } else if (kind === 'island') {
        outLen.textContent = v + (inch ? ' in' : ' cm');
        /* Spacing follows the stool's width: slim 50 cm, standard 55 cm, wide (Carl) 60 cm. */
        var spacing = 55 + arm;
        var n = Math.max(0, Math.floor((cm - walls * 10 + 0.001) / spacing));
        count.textContent = n;
        unit.textContent = (n === 1 ? S[12] : S[13]).replace('%s', inch ? { 50: '19.5', 55: '21.5', 60: '23.5' }[spacing] : spacing);
        dots.innerHTML = new Array(Math.min(n, 12) + 1).join('<i></i>');
        cta.textContent = n < 1 ? S[16] : S[14].replace('%n', n);
      } else {
        outLen.textContent = inch ? num(v, 1) + ' in' : v + ' cm';
        var r = Math.round(cm);
        if (r >= 89 && r <= 92) { count.textContent = inch ? '26 in' : '66 cm'; unit.textContent = S[17]; cta.textContent = S[19].replace('%h', inch ? '26' : '66'); }
        else if (r >= 99 && r <= 102) { count.textContent = inch ? '30 in' : '76 cm'; unit.textContent = S[17]; cta.textContent = S[19].replace('%h', inch ? '30' : '76'); }
        else { count.textContent = inch ? num(Math.round((cm - 25) / 2.54 * 2) / 2, 1) + ' in' : Math.round(cm - 25) + ' cm'; unit.textContent = S[18]; cta.textContent = S[20]; }
      }
    }
    /* Once the visitor has used the calculator, the buy bar carries the result. */
    function toBar() {
      var b = root.querySelector('[data-kbs-bar]');
      if (!b || (kind !== 'island' && kind !== 'table') || +count.textContent < 1) return;
      b.querySelector('[data-kbs-bar-title]').textContent = count.textContent + ' ' + unit.textContent;
      b.querySelector('[data-kbs-bar-sub]').textContent = b.getAttribute('data-each');
    }
    len.addEventListener('input', function () { run(); toBar(); });
    var wIn = el.querySelector('[data-kbs-w]'); if (wIn) wIn.addEventListener('input', run);
    [].slice.call(el.querySelectorAll('[data-kbs-arm],[data-kbs-walls],[data-kbs-ends],[data-kbs-shape],[data-kbs-chair],[data-kbs-front]')).forEach(function (b) { b.addEventListener('click', toBar); });
    run();
  });
})();
